import { createAction, createSlice } from "@reduxjs/toolkit";

export interface ICreateNewRequestHEP {
    stage: number
    isTriggerContinueButton: boolean,
    isTriggerSaveDraftButton: boolean,
    isEnableContinueButton: boolean,
    status: string,
    loading: boolean,
    isEnableSaveDraftButton: boolean,
    stageDirection: number,
    isTriggerRefreshContext: boolean,
    isRequestSubmissionPage: boolean,
}

const INITIAL_STATE = {
    stage: 0,
    isTriggerContinueButton: false,
    isTriggerSaveDraftButton: false,
    isEnableContinueButton: false,
    status: "idle",
    loading: false,
    stageDirection: 1,
    isEnableSaveDraftButton: false,
    isTriggerRefreshContext: false,
    isRequestSubmissionPage: false,
} as ICreateNewRequestHEP;

export const _continueButton = createAction<number>('/hep/saveButton')
export const _saveDraftButton = createAction<number>('/hep/saveDraftButton')
export const _enableContinueButton = createAction<boolean>('/hep/enableContinueButton')
export const _enableSaveDraftButton = createAction<boolean>('/hep/enableSaveDraftButton')
export const _updateStage = createAction<number>('/hep/_updateStage')
export const _triggerRefreshContext = createAction<boolean>('/hep/isTriggerRefreshContext')
export const _setRequestSubmissionPage = createAction<boolean>('/hep/isRequestSubmissionPage')

const createNewRequestHEPSlice = createSlice({
    name: "createNewRequestHEP",
    initialState: INITIAL_STATE,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(_continueButton, (state, action) => {
                state.stage = action.payload;
                state.isTriggerContinueButton = !state.isTriggerContinueButton;
            })
            .addCase(_saveDraftButton, (state, action) => {
                state.stage = action.payload;
                state.isTriggerSaveDraftButton = !state.isTriggerSaveDraftButton;
            })
            .addCase(_enableContinueButton, (state, action) => {
                state.isEnableContinueButton = action.payload;
            })
            .addCase(_updateStage, (state, action) => {
                state.stageDirection = action.payload;
            })
            .addCase(_enableSaveDraftButton, (state, action) => {
                state.isEnableSaveDraftButton = action.payload;
            })
            .addCase(_triggerRefreshContext, (state, action) => {
                state.isTriggerRefreshContext = action.payload;
            })
            .addCase(_setRequestSubmissionPage, (state, action) => {
                state.isRequestSubmissionPage = action.payload;
            })
    },
});

export default createNewRequestHEPSlice;